import { render, staticRenderFns } from "./feedback-dialog.vue?vue&type=template&id=558082f8"
import script from "./feedback-dialog.ts?vue&type=script&lang=js&external"
export * from "./feedback-dialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports